// $(function() {

	var app = angular.module("mainpageApp", []);

	app.controller("TabController", ['$scope', '$http', function TabController($scope, $http) {
		'use strict';

		$scope.tab = 1;
		$scope.tabVersions = {};
		$scope.toplists = {};

		// $http.get('/videohandler?op=getTopVideos').success(function(data) {
		// 	//$scope.toplists = data;
		// 	$scope.toplists = videos;
		// });

		$scope.setTab = function(tab) {
			$scope.tab = tab ? tab : 1;
		};

		$scope.setTabVersion = function(version) {
			if (!version || version < 1)
				version = 1;

			$scope.tabVersions[$scope.tab] = version;
		};

		$scope.isSet = function(tab) {
			return tab == $scope.tab;
		};

		$scope.isVersionSet = function(version) {
			if (typeof $scope.tabVersions[$scope.tab] == "undefined") {
				$scope.tabVersions[$scope.tab] = 1;
			}

			return version == $scope.tabVersions[$scope.tab];
		};
	}]);

	app.controller("AdminController", function() {
		this.adminLayerOpened = 1;
		this.addNewBlockOpened = 0;

		this.toggleAdminLayer = function() {
			if (this.adminLayerOpened)
				this.adminLayerOpened = 0;
			else
				this.adminLayerOpened = 1;
		};

		this.toggleAddNewBlock = function() {
			if (this.addNewBlockOpened)
				this.addNewBlockOpened = 0;
			else
				this.addNewBlockOpened = 1;
		};
	});

	app.controller('VideoController', ['$scope', '$http', function VideoController($scope,$http){
		$scope.videos = [];

		$http.get('/videohandler', {op: 'getTopVideos'}).success(function(data) {
			$scope.videos = data;
		});

		$scope.loadVideos = function() {
			return {};
		};
	}]);

	var videos = {
		viewsDaily: [
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-3.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-2.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-1.jpg",
				isWatchlater: 1
			}
		],
		viewsWeekly: [
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-3.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-1.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-3.jpg",
				isWatchlater: 1
			}
		],
		viewsMonthly: [
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-1.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-2.jpg",
				isWatchlater: 1
			},
			{
				title: "Ez itt valami cím",
				urlTitle: "Ez_itt_valami_cim",
				description: "",
				url: "/",
				duration: "23:14",
				thumb: "http://pics.indavideo.hu/videos/001/790/807/2-3.jpg",
				isWatchlater: 1
			}
		]
	};

// }(window));